import React, {useEffect, useState} from "react";
import {Row, Col, Card, Button,} from "react-bootstrap";
import { useNavigate } from "react-router-dom"
import axios from "axios";
import {useSelector} from "react-redux";

function OperationsDash() {

    let navigate = useNavigate ();

    const [emails, setEmails] = useState([""])
    const [loading, setLoading] = useState(false)

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const getData = async () => {
        setLoading(true)
        try {
            let emails = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/open_home_page_contacts/`, {
            // let emails = await axios.get(`http://127.0.0.1:8000/api/open_home_page_contacts/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setEmails(emails.data)
        }
        catch (err){
            if (err.response){
                console.log(err.response)
                setEmails('None')
            } else if (err.request) {
                console.log(err.request)
                setEmails('None')
            }
        }
        setLoading(false)
    }


    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <h1 className={"banner_heading"}>Operations Dash</h1>
            <br />
            {
                loading
                    ?
                    (
                        <h4>
                            Loading...
                        </h4>
                    )
                    :
                    (
                        <div>
                            <Row >
                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>Manage Work Orders</Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to the managing work orders</Card.Title>
                                            <Card.Text>
                                                Controls Creating Clients, Active Work Orders, and Finished Work Orders
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => navigate('/manage_work_orders')}
                                            >Manage Work Orders</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>Manage Service Orders</Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to the Service Orders</Card.Title>
                                            <Card.Text>
                                                Access to Active Service Order Customers, and Closed Service Orders
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => {navigate('/manage_service_orders')}}>Service Orders</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>Manage Inspections</Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to the inspections</Card.Title>
                                            <Card.Text>
                                                Access to create and manage preexisting inspectors.
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => {navigate('/inspections_dash/')}}>Inspections</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>Logistics Report</Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to the logistics report</Card.Title>
                                            <Card.Text>
                                                Access to Logistics Report where jobs where put on pause for an issue.
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => {navigate('/logistics_report')}}>Logistics Report</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>New Clients Report</Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to a report made up of new clients</Card.Title>
                                            <Card.Text>
                                                Access to New Client Marketing Report that takes notes of ROI on marketing.
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => {navigate('/client_report')}}>New Clients Report</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col sm={12} md={6} lg={4} xl={4}>
                                    <Card>
                                        <Card.Header>
                                            Email Inquiries: YOU HAVE:
                                            <span style={{background: "black", color: 'white', padding: '0 5px'}}>
                                                {emails.length}!
                                            </span>
                                            UNANSWERED EMAILS
                                        </Card.Header>
                                        <Card.Body>
                                            <Card.Title>Access to email inquiries from the home screen</Card.Title>
                                            <Card.Text>
                                                Access to email inquiries from the home screen divided into responded, not responded.
                                            </Card.Text>
                                            <Button variant="primary"
                                                    onClick={ () => {navigate('/email_report')}}>Email Inquiries</Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    )
            }

        </div>
    )
}

export default OperationsDash